import React, { Fragment, useState, useEffect, useRef, useCallback } from "react";
import { Row, Spin, Col } from "antd";
import Loader from "../../../common/cards/Loader";
import UploadPostcard from "../../../common/cards/UploadPostcard";
import ShowCards from "../../../common/cards/FeedCard";
import NoData from "../../../common/cards/noData";
import { useFetchEventAnnoucements } from "../../../common/hooks/useFetchEventAnnoucements";
import { useCreateAnnoucement } from "../../../common/hooks/useCreateAnnouncement";

const DiscussionOrganizer = ({ panelFound, teamFound }) => {
  const [posts, setPosts] = useState([]);
  const [loadMorePosts, setLoadMorePosts] = useState(false);

  const observer = useRef();
  const timer = useRef();
  const isThrottled = useRef(false);

  const { fetchloading, POSTS, setPage, totalPages, page, fetchTime } =
    useFetchEventAnnoucements("organizer");
  const {
    uploadloading,
    IMAGE,
    VIDEO,
    setimage,
    setvideo,
    text,
    setText,
    uploadingMedia,
    setuploadingMedia,
    CreateAnnoucement,
    setLuploading,
    Luploading
  } = useCreateAnnoucement(setPosts, "Organizer", posts);

  useEffect(() => {
    const fetchPosts = async () => {
      setPosts((prevPosts) => [...POSTS, ...prevPosts]);

      const timeoutDuration = Math.max(fetchTime + 100, 500);

      timer.current = setTimeout(() => setLoadMorePosts(false), timeoutDuration);
    };
    fetchPosts();
    return () => clearTimeout(timer.current);
  }, [POSTS, fetchTime]);

  const lastPostElementRef = useCallback(
    (node) => {
      if (fetchloading || isThrottled.current) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setLoadMorePosts(true);
            isThrottled.current = true;
            setTimeout(() => {
              isThrottled.current = false;
            }, 100);
            if (page < totalPages) setPage((prevPage) => prevPage + 1);
          }
        },
        {
          root: null,
          threshold: 0.1
        }
      );
      if (node) observer.current.observe(node);
    },
    [fetchloading, page, totalPages]
  );

  return (
    <Fragment>
      <Row className="mobileto">
        {panelFound && (
          <UploadPostcard
            uploadingMedia={uploadingMedia}
            setuploadingMedia={setuploadingMedia}
            setText={setText}
            text={text}
            IMAGE={IMAGE}
            setimage={setimage}
            VIDEO={VIDEO}
            setvideo={setvideo}
            onPost={CreateAnnoucement}
            loading={uploadloading}
            setLuploading={setLuploading}
            Luploading={Luploading}
          />
        )}
        {fetchloading ? (
          <Loader />
        ) : (panelFound || teamFound) && posts?.length > 0 ? (
          <>
            {posts.map((data, index) => (
              <ShowCards
                key={data?._id || index}
                index={index}
                data={data}
                POSTS={posts}
                setPOSTs={setPosts}
                ref={posts.length === index + 1 ? lastPostElementRef : null}
              />
            ))}
            {loadMorePosts && page < totalPages && (
              <div style={{ textAlign: "center", margin: "20px", width: "100%" }}>
                <Spin tip="Loading more posts..." style={{ color: "black", fontSize: "12px" }} />
              </div>
            )}
          </>
        ) : (
          <Col span={24}>
            <NoData />
          </Col>
        )}
      </Row>
    </Fragment>
  );
};

export default DiscussionOrganizer;
